/**
 * iter339 — Réglage du tarif de gardiennage : petit bouton engrenage dans la page
 * Gardiennage pneus, réservé à l'admin. Ouvre une fenêtre pour fixer le prix.
 */
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Loader2, Settings } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function GardiennageTarifBtn() {
  const [open, setOpen] = useState(false);
  const [tarif, setTarif] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/gardiennages/config")
      .then(({ data }) => setTarif(String(data.tarif_defaut ?? 60)))
      .catch(() => {});
  }, [open]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/gardiennages/config", { tarif_defaut: parseFloat(tarif) });
      toast.success("Tarif de gardiennage enregistré");
      setOpen(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur d'enregistrement");
    } finally { setSaving(false); }
  };

  return (
    <>
      <Button variant="outline" size="icon" onClick={() => setOpen(true)}
              title="Régler le tarif de gardiennage" data-testid="gardiennage-tarif-btn">
        <Settings className="w-4 h-4" />
      </Button>

      <Dialog open={open} onOpenChange={(o) => !o && !saving && setOpen(false)}>
        <DialogContent className="max-w-sm" data-testid="gardiennage-tarif-dialog">
          <DialogHeader>
            <DialogTitle>Tarif de gardiennage</DialogTitle>
            <DialogDescription>
              Appliqué par défaut à chaque nouvelle saison, modifiable au cas par cas.
            </DialogDescription>
          </DialogHeader>
          <div>
            <Label className="text-xs">Tarif par saison (CHF)</Label>
            <Input
              type="number" step="0.05" value={tarif} autoFocus
              onChange={(e) => setTarif(e.target.value)}
              className="mt-1 w-36"
              data-testid="gardiennage-tarif-input"
            />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={saving}>Annuler</Button>
            <Button onClick={save} disabled={saving} className="bg-[#52a675] hover:bg-[#3d8a5c]"
                    data-testid="gardiennage-tarif-save">
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enregistrer"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
